module.exports = "<div [innerHTML]=\"currentText\"></div>\n<a [ngClass]=\"{'hidden': hideToggle}\" (click)=\"toggleView()\">Read {{isCollapsed? 'more':'less'}}</a>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/read-more/read-more.component.html
// module id = ../../../../../src/app/read-more/read-more.component.html
// module chunks = main